document.addEventListener('DOMContentLoaded', function(){
  function productCTA(){
    const ctaContainer = document.querySelector('.buy_buttons--wrap');
    const isMobile = window.innerWidth <= 991;
    
    let threshold = window.innerWidth <= 600 ? 1450 : 1600;
    const hasScrolled = window.scrollY > threshold;

    if (!ctaContainer) return;

    if (isMobile && hasScrolled) {
      ctaContainer.classList.add('cta-fix');
    } else {
      ctaContainer.classList.remove('cta-fix');
    }
  }

  // Run on load
  productCTA();

  // Run on scroll and resize
  window.addEventListener('scroll', productCTA);
  window.addEventListener('resize', productCTA);

  function starReviews(){
    const open_button_star = document.querySelector('.yotpo-sr-bottom-line-summary');

    if (open_button_star) {

      open_button_star.addEventListener('click', function () {

        const reviewSection = document.querySelector('.review-accordion');
        if (!reviewSection) return;

        reviewSection.classList.add('show');

        const parent = reviewSection.parentElement;
        if (parent) {
          const topOffset =
            parent.getBoundingClientRect().top + window.scrollY - 40;

          window.scrollTo({
            top: topOffset,
            behavior: 'smooth'
          });
        }

        const headerSibling = reviewSection.previousElementSibling;
        if (
          headerSibling &&
          headerSibling.classList.contains('accordion-header')
        ) {
          const button = headerSibling.querySelector('.accordion-button');
          if (button) {
            button.classList.remove('collapsed');
          }
        }
      });
    }
  }

  function openReviews() {
    const open_button = document.getElementById('aoc-no-review');
  
    if (!open_button) return;
    open_button.addEventListener('click', function () {
      const reviewSection = document.querySelector('.review-accordion');
  
      if (reviewSection) {
        reviewSection.classList.add('show');
  
        const parent = reviewSection.parentElement;
        if (parent) {
          const topOffset = parent.getBoundingClientRect().top + window.scrollY - 40;
          window.scrollTo({
            top: topOffset,
            behavior: 'smooth'
          });
        }
  
        const headerSibling = reviewSection.previousElementSibling;
        if (headerSibling && headerSibling.classList.contains('accordion-header')) {
          const button = headerSibling.querySelector('.accordion-button');
          if (button) {
            button.classList.remove('collapsed');
          }
        }
      }
    });
  }
  openReviews();

  function showNoReview() {
    const target = document.querySelector('.product-single__meta');
    const noReviewBtn = document.getElementById('aoc-no-review');
  
    if (!target || !noReviewBtn) return;
  
    let mutationTimeout;
  
    const observer = new MutationObserver(() => {
      const hasWidget = target.querySelector('.yotpo-reviews-star-ratings-widget');
  
      if (!hasWidget) {
        // Display if no widget 
        noReviewBtn.style.display = 'block';

        // Change text if no more mutations 
        clearTimeout(mutationTimeout);
        mutationTimeout = setTimeout(() => {
          noReviewBtn.textContent = 'Be the first to review this product!';
        }, 1000);
      } else {
        noReviewBtn.setAttribute("aria-label", "Reviews");
        noReviewBtn.style.display = 'none';
        noReviewBtn.textContent = '';
        starReviews()
        clearTimeout(mutationTimeout);
      }
    });
  
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  
    setTimeout(() => observer.disconnect(), 10000);
  }
  
  showNoReview();


});